import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/SiteFooter";
import { useSiteContent } from "@/lib/content";
import { Mail, MessageCircle, MapPin, PhoneCall, Clock } from "lucide-react";

export default function Contact() {
  const { content } = useSiteContent();
  const c = content?.contact || {};
  const cards = [
    { icon: MessageCircle, label: "WhatsApp", value: c.whatsapp, testid: "contact-whatsapp", href: c.whatsapp ? `https://wa.me/${c.whatsapp.replace(/[^0-9]/g, "")}` : null },
    { icon: Mail, label: "Email", value: c.email, testid: "contact-email", href: c.email ? `mailto:${c.email}` : null },
    { icon: PhoneCall, label: "Phone", value: c.phone, testid: "contact-phone", href: c.phone ? `tel:${c.phone.replace(/\s+/g, "")}` : null },
    { icon: MapPin, label: "Service area", value: c.service_area, testid: "contact-service-area", href: null },
    { icon: Clock, label: "Hours", value: c.hours, testid: "contact-hours", href: null },
  ];
  return (
    <div className="min-h-screen navy-glow flex flex-col" data-testid="contact-page">
      <Navbar variant="public" />
      <main className="flex-1">
        <section className="max-w-5xl mx-auto px-6 py-16">
          <div className="chip mb-6">Get in touch</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight">
            Talk to a <span className="text-brand">geek.</span>
          </h1>
          <p className="text-slate-300 mt-4 max-w-2xl leading-relaxed">
            Reach out on WhatsApp for the fastest response, or drop us an email — a real human replies within a few hours during service hours.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-10">
            {cards.map((card) => (
              <div key={card.label} data-testid={card.testid} className="soft-card p-6 flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-blue-100 text-blue-700 flex items-center justify-center shrink-0">
                  <card.icon className="w-5 h-5" />
                </div>
                <div className="min-w-0">
                  <div className="text-xs font-bold uppercase tracking-wider text-slate-500">{card.label}</div>
                  {card.href ? (
                    <a href={card.href} target="_blank" rel="noreferrer" className="font-display font-bold text-slate-900 mt-1 block break-words hover:text-brand">
                      {card.value}
                    </a>
                  ) : (
                    <div className="font-display font-bold text-slate-900 mt-1 break-words">{card.value}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
